export default __webpack_public_path__ + "static/apple-touch-icon-144x144-ec30cf7ce76a262317c845fde717b02b.png";